<template>
  <v-progress-linear
    max="1"
    color="primary"
    height="25"
    class="bar px-10"
    rounded
  >
    <slot />
  </v-progress-linear>
</template>

<style scoped>
.bar {
  color: #fff;
  width: 96px;
}
</style>